"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.capitalize"));

var _reactComponents = require("@cimpress/react-components");

var _reactI18next = require("react-i18next");

var _index = _interopRequireDefault(require("../i18n/index"));

var ClaimsConstants = _interopRequireWildcard(require("../constants/claims"));

var generateLabelConfig = function generateLabelConfig(status, assignee, t) {
  if (status === ClaimsConstants.OPEN && assignee === ClaimsConstants.MERCHANT) {
    return {
      text: t('underMerchantReview'),
      type: 'info'
    };
  }

  if (status === ClaimsConstants.OPEN && assignee === ClaimsConstants.FULFILLER) {
    return {
      text: t('underFulfillerReview'),
      type: 'warning'
    };
  }

  return {
    text: (0, _lodash["default"])(status),
    type: 'success'
  };
};

var StatusLabel = function StatusLabel(_ref) {
  var status = _ref.status,
      assignee = _ref.assignee;

  var _useTranslation = (0, _reactI18next.useTranslation)('reactClaims', {
    i18n: _index["default"]
  }),
      t = _useTranslation.t;

  var labelConfig = generateLabelConfig(status, assignee, t);
  return _react["default"].createElement(_reactComponents.Label, labelConfig);
};

StatusLabel.propTypes = {
  status: _propTypes["default"].oneOf([ClaimsConstants.OPEN, ClaimsConstants.RESOLVED, ClaimsConstants.REJECTED]).isRequired,
  assignee: _propTypes["default"].oneOf([ClaimsConstants.MERCHANT, ClaimsConstants.FULFILLER]).isRequired
};
var _default = StatusLabel;
exports["default"] = _default;